import { ReactNode } from "react";
import styled from "styled-components";
import Steps from "./Steps";
import { BREAKPOINTS } from "@/globals";

type SidepanelProps = {
	children: ReactNode;
};

export default function Sidepanel({ children }: SidepanelProps) {
	return (
		<SidepanelContainer>
			<SidepanelContent>{children}</SidepanelContent>
			<Steps />
		</SidepanelContainer>
	);
}

const SidepanelContainer = styled.div`
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
	min-width: min(100%, 400px);
	display: flex;
	position: relative;
	max-width: 400px;

	@media (max-width: ${BREAKPOINTS.mobile}px) {
		max-width: 100%;
		justify-content: flex-end;
		flex-direction: column-reverse;
		height: 50vh;
	}
`;

const SidepanelContent = styled.div`
	width: 100%;
	padding: 0.5rem;
	background-color: #f0e9e7;
	overflow: hidden;
	height: 100%;
`;
